import {PermissionKey} from "../helper/permission/enum/PermissionKey";
import {getAuth} from "../helper/utils/getAuth";
import {UserType} from "../helper/permission/enum/UserType";
import {PermissionV2Value} from "../helper/permission/enum/PermissionV2Value";

export function checkPermissionFn(key, requiredLevel) {
    const {
        access,
        isPartner,
        company,
        user,
    } = getAuth();
    const {permissions} = access || {permissions: {}};

    // Bukku Admin
    if (key === PermissionKey.bukkuadmin) {
        if (user.is_landlord === 0)
            return false;
    }

    // Periodic-specific Permisison
    if (key === PermissionKey.stock_value) {
        if (company?.inventory_system !== 'periodic')
            return false;
    }

    // Partner-specific permission
    if (key === PermissionKey.partners) {
        const canManageBilling = access?.partner_portal_access;
        return isPartner && canManageBilling;
    }

    // Manage-user permission
    if (key === PermissionKey.manage_users)
        return access?.manage_users;

    // Manage-billing permission
    if (key === PermissionKey.manage_billing)
        return access?.manage_billing;

    // If user is admin
    if (access.type === UserType.admin)
        return true;

    let level = permissions[key];

    if (key === PermissionKey.reports_all) {
        return !!Object.keys(permissions)
            .filter(key => key.includes('report'))
            .find(key => PermissionV2Value[permissions[key]] > 0);
    }

    // When No permission defined
    if (level === undefined) {
        // Check for parent key
        if (key.includes('.')) {
            const parentKey = key.split('.')[0];
            level = permissions[parentKey];
        }
        // When no permission is defined => null
        else {
            return null;
        }
    }

    // Evaluating
    const value = PermissionV2Value[level];
    const requiredValue = PermissionV2Value[requiredLevel];

    return requiredValue <= value;
}
